module.exports = __webpack_public_path__ + "img/Advantages-icon03.d6ce9909.png";